import React from "react"
import { cn } from "../../lib/utils"

const Card = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={cn(
                "rounded-xl transition-all duration-300",
                {
                    "glass glass-hover shadow-card hover:shadow-card-hover": variant === "default",
                    "glass glass-hover shadow-card hover:shadow-card-hover gradient-border": variant === "glass",
                    "bg-background-surface border border-border hover:border-border-hover shadow-card hover:shadow-card-hover": variant === "grid",
                    "bg-destructive-muted border border-destructive/20 hover:border-destructive/40": variant === "danger",
                    "bg-background-surface border border-border font-mono": variant === "terminal",
                },
                className
            )}
            {...props}
        />
    )
})
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn("flex flex-col space-y-1.5 p-6", className)}
        {...props}
    />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, children, ...props }, ref) => (
    <h3
        ref={ref}
        className={cn("font-display font-semibold leading-tight tracking-tight text-foreground-DEFAULT", className)}
        {...props}
    >{children}</h3>
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
    <p
        ref={ref}
        className={cn("text-sm text-foreground-muted", className)}
        {...props}
    />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
    <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn("flex items-center p-6 pt-0", className)}
        {...props}
    />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
